import { compose, withPropsOnChange } from 'recompose'
import { connect } from 'react-redux'
import { selectCalculatedAffordability, selectMonthlyPayment } from '../../../../../../store/selectors/affordability'

let lastAffordability = 0
let lastMonthlyPayment = 0

const AffordabilityPriceCounterContainer = compose(
  connect(state => ({
    affordability: selectCalculatedAffordability(state) || 0,
    monthlyPayment: selectMonthlyPayment(state) || 0
  })),
  withPropsOnChange(
    (props, nextProps) => {
      if (props.affordability !== nextProps.affordability) {
        lastAffordability = props.affordability
      }
      if (props.monthlyPayment !== nextProps.monthlyPayment) {
        lastMonthlyPayment = props.monthlyPayment
      }

      return true
    },
    () => ({
      lastAffordability,
      lastMonthlyPayment
    })
  )
)

export default AffordabilityPriceCounterContainer
